import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RouteReuseStrategyService } from '../../services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss']
})
export class AccountPageComponent implements OnInit, OnDestroy {

  @ViewChild("container", { static: true }) containerRef: ElementRef;
  private takeUntilSubject: Subject<any> = new Subject();

  constructor(
    private routeReuseStrategyService: RouteReuseStrategyService
  ) {}

  selectCoverImageValue = null
  selectedLogoValue = null

  ngOnInit(): void {
    const styles = window['documentManager'].createElement('link');
    styles.href = 'paybee-spa/styles.css?v=398';
    styles.rel = 'stylesheet';
    window['$'](this.containerRef.nativeElement).append(styles);
  }

  ngOnDestroy(): void {
    const $ = window['$'];
    $("#account").hide();
    $("#account").empty();

    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
